/*
* 暂时只作于品牌广告上传LOGO
*/
<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
    :confirm-loading="confirmLoading"
    :size="size"
    no-padding
    :content-style="{padding: '18px 18px 4px'}"
    @cancel="cancel"
    @confirm="confirm">
    <template #header>
      <span>{{title}}</span>
    </template>
    <template #content>
      <vueCropper
        ref="cropper"
        :src="file"
        :img="option.img"
        :outputSize="option.size"
        :outputType="option.outputType"
        :full="option.full"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :original="option.original"
        :autoCrop="option.autoCrop"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        :centerBox="option.centerBox"
        :infoTrue="option.infoTrue"
        :fixedBox="option.fixedBox"
        v-loading="loading"
      ></vueCropper>
      <el-row class="img-info" v-if="file">
        <el-col :span="8" class="img-info-left">
          <span>图片名称：{{ fileData.name }}</span>
        </el-col>
        <el-col :span="16" class="img-info-right">
          <span>尺寸：{{ fileData.width }}*{{ fileData.height }}像素</span>
          <span>大小：{{ fileData.size }}KB</span>
          <span>格式：{{ fileData.type }}</span>
        </el-col>
      </el-row>
      <gj-upload-attach
        class="upload-attach"
        :fileList="fileList"
        :beforeUpload="beforeUpload">
        <gj-button type="primary" size="mini">{{ option.img ? "重新上传" : "上传图片" }}</gj-button>
      </gj-upload-attach>
      <div class="list-specifications">
        <el-row class="specifications-title">{{ specifications.title }}</el-row>
        <el-row>
          <el-col class="specifications-cell" v-for="(item, index) in specifications.list" :key="index" :span="12">{{ item }}</el-col>
        </el-row>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {formRuleMixin, modalMixIn} from "@/minxins";
import { VueCropper } from 'vue-cropper'
import { uploadImage } from '@/api/ad'
export default {
  name: 'gj-upload-img',
  mixins: [modalMixIn, formRuleMixin],
  components: { VueCropper },
  props: {
    title: {
      default: "上传"
    },
    size: {
      default: "700XAuto"
    },
    marketId: {
      default: null
    },
    brandEntityId: {
      default: null
    },
    specifications: {
      type: Object,
      default: () => ({
        title: "",
        list: []
      })
    },
    acceptType: {
      default: () => []
    }
  },
  data() {
    return {
      // 裁剪组件的基础配置option
      loading: false,
      file: null,
      addBase: {},
      fileData: {
        width: "",
        height: "",
        name: "",
        size: "",
        type: "",
      },
      fileList: [],
      mockFile: null,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [0.9, 0.9], // 截图比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    };
  },
  methods: {
    // 上传前处理
    beforeUpload(file) {
      if (this.acceptType.length > 0 && this.acceptType.indexOf(file.type) === -1) {
        this.$gjMessage.error('无法接受的文件类型');
        return false;
      }
      this.file = file
      this.fileData.name = file.name
      this.fileData.type = file.type
      this.fileData.size = this._.floor(file.size / 1024, 2);
      this.getImgWH(this.file)
      this.option.img = window.URL.createObjectURL(file)
      return false;
    },
    // 获取file文件宽高
    getImgWH(fileData) {
      //读取图片数据
      var reader = new FileReader();
      let _this = this
      reader.onload = function (e) {
          var data = e.target.result;
          //加载图片获取图片真实宽度和高度
          var image = new Image();
          image.onload=function(){
            _this.fileData.width = image.width
            _this.fileData.height = image.height
          };
          image.src= data;
      };
      reader.readAsDataURL(fileData)
    },
    confirm() {
      if (!this.option.img) return this.$gjMessage.warning("请先上传图片")
      this.$refs.cropper.getCropBlob( async data => {
        this.loading = true
        let files = new window.File([data], this.fileData.name, {type: this.fileData.type})
        let formData = new FormData();
        formData.append('file', files);
        formData.append('marketId', this.marketId);
        formData.append('brandEntityId', this.brandEntityId);
        try {
          let { data } = await uploadImage(formData)
          // 后端说的
          setTimeout(() => {
            data.code == "SUCCESS" ? this.$gjMessage.success("上传成功") : this.$gjMessage.error(data.code.detail)
            this.$gjDestroy();
            this.$emit("update", data)
          }, 500);
        } finally {
          setTimeout(() => {
            this.loading = false
          }, 500);
        }
      })
    },
    confirmXXXX() {
      this.$refs.cropper.startCrop()  // 开始截图
      setTimeout(() => {
        this.$refs.cropper.stopCrop() // 停止截图
        this.$refs.cropper.getCropBlob( async (data) => {
          let files = new window.File([data], this.fileData.name, {type: this.fileData.type})
          let formData = new FormData();
          formData.append('file', files);
          formData.append('marketId', this.marketId);
          formData.append('brandEntityId', this.brandEntityId);
          let res = await uploadImage(formData)
        })
      }, 100);
    }
  },
};
</script>

<style scoped lang='scss'>
/deep/.vue-cropper {
  width: 100%;
  height: 200px !important;
}
/deep/.crop-info {
  // display: none;
}
.upload-attach {
  padding: 10px 0;
}
.list-specifications {
  padding: 10px 0;
  font-size: 12px;
  color: #333333;
  .specifications-title {
    font-weight: 500;
    padding-bottom: 10px;
  }
  .specifications-cell {
    &::before {
      content: "";
      margin-right: 6px;
      display: inline-block;
      width: 8px;
      height: 8px;
      opacity: 0.4;
      background: #666666;
      border-radius: 100%;
    }
  }
}
.img-info {
  padding: 7px 0 0;
  font-size: 12px;
  color: #666666;
  .img-info-right {
    text-align: right;
    span {
      padding-left: 20px;
    }
  }
}
</style>